import angular from 'angular';
import { errorLoggerDecorator } from './errorLoggerDecorator';
import 'components/sharpr/identity/identityModule';
import 'components/sharpr/eventTracker/eventTrackerModule';

angular.module('sh.errorLogger', ['sh.identity', 'sh.eventTracker']).config(errorLoggerDecorator);
